export enum WhatsappAccountTab {
  account = "account",
  taskTemplates = "taskTemplates",
  messageTemplates = "messageTemplates",
  logsHistory = "logsHistory",
}

export enum WhatsappAccountMenuTab {
  generalInfo = "generalInfo",
  businessVerification = "businessVerification",
  twoFactorAuthentication = "woFactorAuthentication",
  waProfile = "waProfile",
  clientsContactDetails = "clientsContactDetails",
  qualityRating = "qualityRating",
}
